module.exports = __webpack_public_path__ + "static/img/piglet4.5fe4ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/piglet4.png
// module id = 14u8
// module chunks = 2